import styles from '../Measures/Measures.module.scss';
import { Flex, PageHeader, PageRow, LinkItem } from '../../ui';

const Announcements202505 = () => {
  return (
    <>
      <div className={styles.Announcements}>
        <PageHeader.Row>
          <PageHeader.Title>
            AHRQ Public Listening Session on Opportunities to Update the Patient Safety Indicators
          </PageHeader.Title>
        </PageHeader.Row>
        <PageRow lightGrey>
          <Flex fontSize={18}>
            <h2 className='my-3'>Webinar on PSI Gap Analysis Findings</h2>
            <h4 className='my-3'>May 7, 2025, 1:00 p.m. - 2:30 p.m. EDT</h4>
            <p>
              On May 7, 2025, AHRQ held a listening session to review interim findings from a gap
              analysis to identify opportunities for future Patient Safety Indicator (PSI)
              measurement, including opportunities to expand PSIs to new care settings and
              populations.
            </p>
            <p>
              AHRQ welcomes additional comments on the interim findings from interested
              stakeholders, including (but not limited to) patients and patient advocacy groups,
              healthcare organizations, clinicians, patient safety experts, trade associations,
              health plans, and state and local health departments. Any comments in response to the
              webinar may be sent via email (
              <a href='mailto:patientsafety@mitre.org'>patientsafety@mitre.org</a>) by June 27,
              2025.
            </p>
          </Flex>
        </PageRow>
        <PageRow>
          <Flex fontSize={18}>
            <h4>Documents</h4>
            <LinkItem
              href='/Downloads/Resources/ListeningSessionVersion_GapAnalysis_May_2025.pdf'
              meta='PDF File, 402 KB'
              mb
              className={'my-2'}
            >
              AHRQ's Patient Safety Indicators: Gap Analysis and Update Opportunities
            </LinkItem>
            <LinkItem
              href='/Downloads/Resources/Opportunities to Update the AHRQ PSI Program Webinar Slides 05.07.25.pdf'
              meta='PDF File, 2.38 MB'
              mb
              className={'my-2'}
            >
              Webinar Slides, May 7, 2025
            </LinkItem>
            <LinkItem
              to='https://www.youtube.com/watch?v=SV4L6Z_lMWM'
              meta=''
              mb
              className={'my-0'}
            >
              Webinar Recording Video, May 7, 2025
            </LinkItem>
          </Flex>
        </PageRow>
        <PageRow>
          <Flex fontSize={18}>
            <h4>Timeline</h4>
            <img alt='external web link policy' src='/images/timeline_PSI.png' />
            <p className='lead italic-footnote'>
              Please refer to the webinar slide for more details.
            </p>
          </Flex>
        </PageRow>
      </div>
    </>
  );
};

export default Announcements202505;
